import ClientAllProducts from "../../../Components/Client/ClientAllProducts";

const ClientProductsPage = () => {
  return <ClientAllProducts />;
};

export default ClientProductsPage;
